import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { MorningMinutesPage } from './morning-minutes';
import { MorningMinutesComponentModule } from '../morning-minutes-component/morning-minutes-component.module';
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    MorningMinutesPage,
  ],
  imports: [
    DirectivesModule,
    IonicPageModule.forChild(MorningMinutesPage),
    MorningMinutesComponentModule,
  ],
})
export class MorningMinutesPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/morning-minutes/morning-minutes/morning-minutes.module.ts